// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__2pq5K"};